export default "__VITE_ASSET__DpeKDkTC__"